
import { Component, Inject, Vue } from "vue-property-decorator";
import Layout from "./molecules/layout/Layout.vue";
import { Container } from "inversify";
import { AuthStore } from "../../common/src/stores/AuthStore";
import TermsConditionModal from "./molecules/components/TermsConditionModal.vue";
@Component({
    components: { Layout, TermsConditionModal },
})
export default class App extends Vue {
    @Inject("container") container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    routerLoaded: boolean = false;

    created() {
        this.$router.afterEach(() => {
            this.routerLoaded = true;
        });
    }

    get loaded(): boolean {
        return this.authStore.loaded && this.routerLoaded;
    }
}
